const getInitialRedirection = (accesses) => {
  if (accesses.hasFullAccess) {
    return "/products"
  }

  if (!!accesses["viewProducts"]) {
    return "/products"
  }

  if (!!accesses["viewServices"]) {
    return "/services"
  }

  if (!!accesses["viewCustomerService"]) {
    return "/customer-service"
  }

  if (!!accesses["viewSubscriptionGifts"]) {
    return "/subscription-gifts"
  }

  if (!!accesses["editSmsPrice"]) {
    return "/sms"
  }

  if (!!accesses["editAppVersion"]) {
    return "/app-version"
  }

  if (!!accesses["viewRoleManagement"]) {
    return "/role-management"
  }

  if (!!accesses["viewAccountManagement"]) {
    return "/account-management"
  }

  return ""
}

export default getInitialRedirection